import "bootstrap/dist/css/bootstrap.min.css";
// import $ from 'jquery';
// import Popper from 'popper.js';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

console.log('index.tsx is being executed');

const container = document.getElementById("root");
console.log('Root container:', container);

if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);
console.log('Root created');

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
